
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { User, UserApi, AuthApi } from "../../autogen";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import UIkit from "uikit";
import SearchField from "../atoms/SearchField.vue";
import UserForm from "../organisms/UserForm.vue";
import Store from "../../store";

type UserView = User & { name?: string; roleName?: string };

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    UserForm,
    SearchField
  }
})
export default class Users extends Vue {
  users: UserView[] = [];
  user: UserView | null = null;
  protected readonly storeInstance = Store.getInstance();
  query = "";
  header = [
    { title: "ユーザーID", sortable: true, key: "username", width: "expand" },
    { title: "氏名", sortable: true, key: "name", width: "expand" },
    { title: "メールアドレス", sortable: true, key: "email", width: "expand" },
    { title: "権限", sortable: true, key: "roleName", width: "expand" },
    { title: "編集", type: "button", key: "edit", width: 150 }
  ];
  filterColumns = ["name", "username", "email", "roleName"];
  @Ref("modal") modal!: HTMLElement;
  formKey = 0;
  renewKey = 0;

  private async loadData() {
    const response = await new UserApi().getUsers({
      clientId: this.$route.params.clientId as string,
      q: this.query
    });
    const roleDict = await this.getRoles();
    this.users = response.data.map(user =>
      Object.assign(
        { name: `${user.lastName} ${user.firstName}`, roleName: user.role in roleDict ? roleDict[user.role] : "" },
        user
      )
    );
    this.renewKey = Date.now();
  }
  async beforeMount() {
    await this.loadData();
  }
  async mounted() {
    if (this.$route.query["id"]) {
      const userId = this.$route.query["id"] as string;
      const response = await new UserApi().getUser({ userId });
      this.user = response.data;
      this.$router.replace({ query: {} });
      this.prepareForm();
    }
  }
  onAddButtonClick() {
    this.user = null;
    this.prepareForm();
  }
  private closeForm() {
    UIkit.modal(this.modal).hide();
  }
  private prepareForm() {
    this.formKey = Date.now();
    UIkit.modal(this.modal).show();
  }
  onColumnClick(location: { row: number; col: string }) {
    if (location.col === "edit") {
      this.user = this.users[location.row];
      this.prepareForm();
    }
  }
  async onSubmitted() {
    this.closeForm();
    await new AuthApi().authenticate({}).then(resp => {
      if (resp.status === 200) {
        Store.getInstance().setAuth(resp.data);
      }
    });
    await this.loadData();
  }
  async onSearch(searchResult: [] | null) {
    if (searchResult) {
      this.users = searchResult;
    } else {
      await this.loadData();
    }
  }
  private async getRoles() {
    const roles = (await new AuthApi().getRoles({})).data;
    const roleDict: { [key: string]: string } = { "1": "システム管理者" };
    roles.map(function(obj) {
      roleDict[obj.id] = obj.name;
    });
    return roleDict;
  }
}
